import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';

import { NotificationRecipient } from '@vi-iot/client';
import { PageEvent } from '@angular/material/paginator';
import { NotificationRecipientsStatus, NotificationsStore } from '@store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-configure-notification-recipients',
  templateUrl: './configure-notification-recipients.component.html',
  styleUrls: ['./configure-notification-recipients.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigureNotificationRecipientsComponent implements OnInit, OnDestroy {
  NotificationRecipientsStatus = NotificationRecipientsStatus;

  sourcedRecipients: NotificationRecipient[] = [];
  processedRecipients: NotificationRecipient[] = [];

  pagination = {
    page: 0,
    pageSize: 5,
  };

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(public notificationsStore: NotificationsStore, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.notificationsStore.getNotificationRecipients();

    this.onRecipientsUpdated();
  }

  onToggleChanged(event: MatSlideToggleChange, recipient: NotificationRecipient): void {
    this.notificationsStore.updateNotificationRecipient(event.checked, recipient);
  }

  onPageChange(paginator: PageEvent): void {
    const nextPage = paginator.pageIndex > -1 ? paginator.pageIndex : 0;
    this.pagination.page = nextPage;
    this.setRecipientsToDisplay();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private onRecipientsUpdated(): void {
    this.notificationsStore.notificationRecipients$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter((entry) => entry?.length > 0)
      )
      .subscribe((recipients: NotificationRecipient[]) => {
        this.sourcedRecipients = recipients;
        this.setRecipientsToDisplay();
        this.cdr.markForCheck();
      });
  }

  private setRecipientsToDisplay(): void {
    const startIndex =
      (this.pagination.page + 1) * this.pagination.pageSize - this.pagination.pageSize;
    const endIndex = (this.pagination.page + 1) * this.pagination.pageSize;
    this.processedRecipients = this.sourcedRecipients.slice(startIndex, endIndex);
  }
}
